/**
 * Globals the 2016 code expects (it was bundled with Browserify and plain <script> plugins).
 * Imported first in main.js so these exist before any module runs.
 */
import $ from 'jquery';

// jQuery plugins (Slick, the PhotoSwipe wrapper) attach to the global jQuery
window.$ = window.jQuery = $;

// The 2016 code uses GSAP 1.x's globals (TweenMax, TimelineMax, Power2, etc.).
// GSAP's package.json marks only TweenLite/index as having side effects, so a production
// build drops the modules that would register these on window. Import them by name instead.
// (`gsap` is aliased to its ESM build in vite.config.ts; the plugin must come from the same build)
import { TweenLite, TweenMax, TimelineLite, TimelineMax, Power2, Linear } from 'gsap';
import ScrollToPlugin from 'gsap/esm/ScrollToPlugin.js';

Object.assign(window, { TweenLite, TweenMax, TimelineLite, TimelineMax, Power2, Linear, ScrollToPlugin });
